import '@babel/polyfill';
import Vue from 'vue';
import './plugins/index'
import App from './App.vue';
import router from './router';
import store from './store';

import i18n from './i18n/'

import helper from './helper'
global.helper = helper


import commonUtils from './mixins/utils'
Vue.mixin(commonUtils)
import loadingEventLaucher from './mixins/loadingEventLauncher'
Vue.mixin(loadingEventLaucher)

import timingUtils from './mixins/timing'
Vue.mixin(timingUtils)


import VueDayjs from 'vue-dayjs-plugin'
Vue.use(VueDayjs)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)


Vue.filter('formatDateTime', function (value, from, to) {
    if (!value) return ''
    const moment = require('moment');
    let d1 = moment(value, from);
    let d2 = d1.format(to)
    return d2;
})

import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)


import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
    iconfont: 'mdi'
});



Vue.config.productionTip = false;

const app = new Vue({
    CountryFlag,
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
if (window.Cypress) {
    window.app = app;
}
